import axios, { AxiosResponse } from 'axios';
import { ContentTypeItem, ContentTypeFormData } from '@src/types/knowledgeBase';

// ─── Resource shapes ────────────────────────────────────────────────────────

export type KnowledgeBaseRes = {
  id: number;
  name: string;
  type_id: number;
  type?: ContentTypeItem;
  content: string;
  is_published?: boolean;
  published_at?: string;
};

/** Response shape for list endpoints — already grouped by type on the backend */
export type KnowledgeBaseGroupByTypeRead = {
  name: string;
  type_id: number;
  knowledge: KnowledgeBaseRes[];
};

export type KnowledgeBaseCreateUpdatePayload = {
  name: string;
  type_id: number;
  content: string;
  is_published?: boolean;
  published_at?: string;
};

// ─── Knowledge Base CRUD (user / admin) ──────────────────────────────────────

export const getKnowledgeBases = (params?: {
  type_id?: number;
}): Promise<AxiosResponse<KnowledgeBaseGroupByTypeRead[]>> =>
  axios.get(`/knowledge-base/`, { params });

export const getAdminKnowledgeBases = (params?: {
  type_id?: number;
}): Promise<AxiosResponse<KnowledgeBaseGroupByTypeRead[]>> =>
  axios.get(`/admin/knowledge-base/`, { params });

export const getKnowledgeBaseDetail = (
  id: number
): Promise<AxiosResponse<KnowledgeBaseRes>> =>
  axios.get(`/admin/knowledge-base/${id}/`);

export const createKnowledgeBase = (
  data: KnowledgeBaseCreateUpdatePayload
): Promise<AxiosResponse<KnowledgeBaseRes>> =>
  axios.post(`/admin/knowledge-base/`, data);

export const updateKnowledgeBase = (
  id: number,
  data: Partial<KnowledgeBaseCreateUpdatePayload>
): Promise<AxiosResponse<KnowledgeBaseRes>> =>
  axios.put(`/admin/knowledge-base/${id}/`, data);

export const deleteKnowledgeBase = (id: number) =>
  axios.delete(`/admin/knowledge-base/${id}/`);

// ─── Knowledge Base Types (Admin) ────────────────────────────────────────────

export const getKnowledgeBaseTypes = (params?: {
  is_active?: boolean;
}): Promise<AxiosResponse<ContentTypeItem[]>> =>
  axios.get(`/admin/knowledge-base-types/`, { params });

export const createKnowledgeBaseType = (
  data: ContentTypeFormData
): Promise<AxiosResponse<ContentTypeItem>> =>
  axios.post(`/admin/knowledge-base-types/`, data);

export const updateKnowledgeBaseType = (
  id: number,
  data: Partial<ContentTypeFormData>
): Promise<AxiosResponse<ContentTypeItem>> =>
  axios.patch(`/admin/knowledge-base-types/${id}/`, data);

export const deleteKnowledgeBaseType = (id: number) =>
  axios.delete(`/admin/knowledge-base-types/${id}/`);
